// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18kPA","name":"Header_name__1hCkC","birthday":"Header_birthday__3edsg","skeleton":"Header_skeleton__r3qX_"};